import React, { useEffect, useState } from "react";
import "./AdvancedCoursePage.css";
import stick3 from "../../../Assets/thinking.jpg";
import stick4 from "../../../Assets/comfident.jpg";
import stick1 from "../../../Assets/adavence.jpg";
import stick2 from "../../../Assets/framing.jpg";
import PopupForm from "../../../Form/PopupForm";

const AdvancedCoursePage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);
    const handleOpenForm = () => setShowForm(true);
  const handleCloseForm = () => setShowForm(false);

  useEffect(() => {
    setIsVisible(true);

    const animateOnScroll = () => {
      const elements = document.querySelectorAll(".advanced-animate-on-scroll");
      elements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (elementTop < windowHeight - 100) {
          element.classList.add("advanced-visible");
        }
      });
    };

    window.addEventListener("scroll", animateOnScroll);
    animateOnScroll();

    return () => window.removeEventListener("scroll", animateOnScroll);
  }, []);

  return (
    <div className="advanced-page">
      {/* Hero Section */}
      <section className="advanced-hero-section">
        <div
          className={`advanced-hero-content ${
            isVisible ? "advanced-visible" : ""
          }`}
        >
          <div className="advanced-decorative-circle" />
          <div className="advanced-decorative-circle advanced-circle-2" />
          <h1>
            ADVANCED LEVEL{" "}
            <span className="advanced-highlight">IMPACT SPEAKER</span>
          </h1>
          <p className="advanced-tagline">
            Speak like a pro—confident, clear, and ready for any situation.
          </p>
         <div className="advanced-cta-container">
            <button onClick={handleOpenForm} className="advanced-cta-button">
              Start Your Journey 
            </button>
            {/* Make free trial badge clickable */}
            <div 
              onClick={handleOpenForm} 
              className="advanced-free-trial-badge" 
              style={{ cursor: 'pointer' }}
              role="button" 
              tabIndex={0}
              onKeyPress={(e) => { if(e.key === 'Enter' || e.key === ' ') handleOpenForm(); }}
            >
              <span>FREE TRIAL</span>
              <div className="advanced-pulse"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Course Promise Section */}
      <section className="advanced-course-promise advanced-animate-on-scroll">
        <div className="advanced-shadow-box">
          <h2>MASTER PROFESSIONAL COMMUNICATION</h2>
          <div className="advanced-promise-content">
            <div className="advanced-decorative-ring" />
            <p>
              At the <span className="advanced-highlight">Advance Level</span>,
              you will be able to engage in complex discussions, express
              abstract ideas clearly, use idiomatic language naturally, and
              speak fluently in academic, business, and social contexts.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="advanced-benefits-section advanced-animate-on-scroll">
        <h2>WHAT YOU'LL ACHIEVE</h2>
        <div className="advanced-benefits-container">
          {[
            {
              title: "Advanced Sentence Structures",
              desc: "Master intonation, stress patterns, and complex sentence structures for sophisticated expression",
              image: stick1,
            },
            {
              title: "Framing Arguments",
              desc: "Learn to develop and present compelling arguments and counterarguments in discussions",
              image: stick2,
            },
            {
              title: "Critical Thinking",
              desc: "Enhance your ability to analyze, evaluate, and debate complex topics with clarity",
              image: stick3,
            },
            {
              title: "Confident Presentation",
              desc: "Develop skills for impactful professional and academic presentations",
              image: stick4,
            },
          ].map((item, index) => (
            <div className="advanced-benefit-card" key={index}>
              <img
                src={item.image}
                alt={item.title}
                className="advanced-benefit-image"
              />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Features Section */}
      <section className="advanced-features-section advanced-animate-on-scroll">
        <h2>EXCLUSIVE PROGRAM FEATURES</h2>
        <div className="advanced-features-grid">
          {[
            "Speaking like a native",
            "Accent neutralization exercises",
            "Fluency test and performance review",
          ].map((feature, idx) => (
            <div className="advanced-feature-item" key={idx}>
              <div className="advanced-check-icon" />
              <p>{feature}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Course Structure Section */}
      <section class="advanced-course-structure advanced-animate-on-scroll">
        <h2>YOUR 30-DAY MASTERY PLAN</h2>
        <div class="advanced-timeline">
            {/* <!-- Stick Figure --> */}
            <div class="stick-figure">
                <svg viewBox="0 0 30 40" xmlns="http://www.w3.org/2000/svg">
                    {/* <!-- Head --> */}
                    <circle cx="15" cy="6" r="4" stroke="#333" stroke-width="2" fill="none"/>
                    {/* <!-- Body --> */}
                    <line x1="15" y1="10" x2="15" y2="25" stroke="#333" stroke-width="2"/>
                    {/* <!-- Arms --> */}
                    <line x1="15" y1="15" x2="8" y2="20" stroke="#333" stroke-width="2"/>
                    <line x1="15" y1="15" x2="22" y2="20" stroke="#333" stroke-width="2"/>
                    {/* <!-- Legs --> */}
                    <line x1="15" y1="25" x2="8" y2="35" stroke="#333" stroke-width="2"/>
                    <line x1="15" y1="25" x2="22" y2="35" stroke="#333" stroke-width="2"/>
                    {/* <!-- Hands --> */}
                    <circle cx="8" cy="20" r="1.5" fill="#333"/>
                    <circle cx="22" cy="20" r="1.5" fill="#333"/>
                    {/* <!-- Feet --> */}
                    <circle cx="8" cy="35" r="1.5" fill="#333"/>
                    <circle cx="22" cy="35" r="1.5" fill="#333"/>
                </svg>
            </div>

            <div class="advanced-timeline-item">
                <div class="advanced-timeline-point"></div>
                <div class="advanced-timeline-content">
                    <h3>Week 1: Advanced Expression</h3>
                    <p>Master complex sentence structures, sophisticated vocabulary, and nuanced expression</p>
                </div>
            </div>
            <div class="advanced-timeline-item">
                <div class="advanced-timeline-point"></div>
                <div class="advanced-timeline-content">
                    <h3>Week 2: Debate & Discussion</h3>
                    <p>Develop skills in framing arguments, providing evidence, and engaging in high-level discussions</p>
                </div>
            </div>
            <div class="advanced-timeline-item">
                <div class="advanced-timeline-point"></div>
                <div class="advanced-timeline-content">
                    <h3>Week 3: Professional Communication</h3>
                    <p>Perfect presentation skills, negotiate effectively, and handle complex business scenarios</p>
                </div>
            </div>
            <div class="advanced-timeline-item">
                <div class="advanced-timeline-point"></div>
                <div class="advanced-timeline-content">
                    <h3>Week 4: Mastery & Refinement</h3>
                    <p>Polish your communication style, eliminate subtle errors, and achieve near-native fluency</p>
                </div>
            </div>
        </div>
    </section>

      {/* Transformation Section */}
      <section className="advanced-transformation-section advanced-animate-on-scroll">
        <h2>YOUR TRANSFORMATION JOURNEY</h2>
        <div className="advanced-before-after-container">
          <div className="advanced-before-box">
            <h3>BEFORE</h3>
            <ul>
              <li>Difficulty with complex discussions</li>
              <li>Struggling with idiomatic expressions</li>
              <li>Limited presentation skills</li>
              <li>Noticeable non-native accent</li>
              <li>Hesitation in professional settings</li>
            </ul>
          </div>
          <div className="advanced-arrow-transform">
            <div className="advanced-arrow-body" />
            <div className="advanced-arrow-head" />
          </div>
          <div className="advanced-after-box">
            <h3>AFTER</h3>
            <ul>
              <li>Confidently engaging in complex topics</li>
              <li>Natural use of idiomatic language</li>
              <li>Impactful presentation delivery</li>
              <li>Refined accent and pronunciation</li>
              <li>Executive-level communication skills</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section
        id="enroll"
        className="advanced-pricing-section advanced-animate-on-scroll"
      >
        <h2>INVEST IN YOUR EXCELLENCE</h2>
        <div className="advanced-pricing-box advanced-shadow-box">
          <div className="advanced-decorative-circle advanced-pricing-circle" />
          <h3>ADVANCED COURSE: IMPACT SPEAKER</h3>
          <div className="advanced-price-tag">
            <button onClick={handleOpenForm} className="advanced-free-trial-badge-large">
              TRIAL FREE
            </button>
            <div className="advanced-pulse-large"></div>
          </div>
          <button onClick={handleOpenForm} className="advanced-enroll-button">
            Enroll Now
          </button>
        </div>
      </section>
<PopupForm isOpen={showForm} onClose={handleCloseForm} />

      {/* Final CTA Section */}
    </div>
  );
};

export default AdvancedCoursePage;
